/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react'
import { Button, Input, Row } from 'antd'
import { useTranslation } from 'next-i18next'
import { useWindowSize } from 'src/app/hooks'
import { CustomCol, CustomTitle } from 'src/components'
import { PlusOutlined, SearchOutlined } from '@ant-design/icons'
import CreatePushNotificationForm from './CreatePushNotificationForm/CreatePushNotificationForm'

interface CampaignListHeaderProps {
  length: number
}

const PushNotificationsListHeader: React.FC<CampaignListHeaderProps> = (props) => {
  const { length } = props
  const { t } = useTranslation()
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false)
  const { isMobile } = useWindowSize()

  return <>
    <Row>
      <CustomCol lg={18}>
        <CustomTitle
          label={t('general.ResultsLength', { length })}
          type={null}
        />
      </CustomCol>
      <CustomCol lg={6}>
        <Button
          type='dashed'
          size='middle'
          block={isMobile}
          icon={<PlusOutlined />}
          className={isMobile ? 'mt-2': 'ml-3'}
          onClick={() => setIsModalVisible(true)}
        >
          {t('Create Push Notification')}
        </Button>
      </CustomCol>
    </Row>

    <CreatePushNotificationForm
      isModalVisible={isModalVisible}
      setIsModalVisible={() => setIsModalVisible(false)}
    />
  </>
}

export default PushNotificationsListHeader
